<template>
  <div id="app">
    <Loading v-if="loading" :loadname="loadname" />
    <!-- 获取完店铺配置 结束loading后才能进入首页路由 -->
    <div id="nav" v-if="!loading" v-show="$route.meta.navShow">
      <div @click="go('/')" :class="path == '/' ? 'active' : ''">
        <div class="navbar">
          <md-icon name="home" style="font-size: 0.52rem"></md-icon>
          <span>首頁</span>
        </div>
      </div>
      <div @click="go('/package')" :class="path == '/package' ? 'active' : ''">
        <div class="navbar">
          <md-icon name="calendar" style="font-size: 0.52rem"></md-icon>
          <span>包裹</span>
        </div>
      </div>
      <div @click="go('/order')" :class="path == '/order' ? 'active' : ''">
        <div class="navbar">
          <md-icon name="order" style="font-size: 0.52rem"></md-icon>
          <span>訂單</span>
        </div>
      </div>
      <div @click="go('/my')" :class="path == '/my' ? 'active' : ''">
        <div class="navbar">
          <md-icon name="user" style="font-size: 0.52rem"></md-icon>
          <span>我的</span>
        </div>
      </div>
    </div>
    <keep-alive>
      <router-view v-if="!loading && isReloadAlive" v-wechat-title="$route.meta.title" />
    </keep-alive>
  </div>
</template>
<script>
import { Field, CellItem, Dialog, Button } from 'mand-mobile';
import { getUrlKey } from '../src/until/getUrlcode';
import Loading from '../src/components/HomeLoading.vue';

export default {
  name: 'App',
  components: {
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    Loading,
  },
  data() {
    return {
      path: '/',
      isReloadAlive: true,
      loading: true,
      loadname: '资源加载中11%',
      ishor: false,
    };
  },
  watch: {
    $route: 'getPath',
  },
  created() {
    // 根据地址域名获取店铺配置信息
    const isProd = process.env.NODE_ENV === 'production';

    this.appContext();

    if (getUrlKey('cnm', window.location.href)) {
      // APP Webview跳转进入
      this.loading = false;
      return false;
    }
    if (getUrlKey('code', window.location.href)) {
      this.ishor = true;
      this.getwein();
    }
    if (this.ishor) {
      return;
    }
    this.loading = true;
    let storeUrl = '';
    let appCode = '';
    let par = {};
    localStorage.removeItem('rqCode')
    // 邀请注册码
    let rqCode = getUrlKey('rqCode', window.location.href)
      ? localStorage.setItem('rqCode', getUrlKey('rqCode', window.location.href))
      : '';
    let parentCode = getUrlKey('parentCode', window.location.href)
      ? getUrlKey('parentCode', window.location.href)
      : '';
    if (
      getUrlKey('tbId', window.location.href) ||
      getUrlKey('storeUrl', window.location.href)
    ) {
      // 根据地址参数获取店铺配置
      this.loadname = '资源加载中20%';
      console.log('地址参数');
      storeUrl = getUrlKey('storeUrl', window.location.href);
      appCode = getUrlKey('tbId', window.location.href);
      par = {
        appCode: appCode,
        storeUrl: storeUrl,
      };
    } else {
      // 根据域名获取店铺配置
      console.log('域名');
      this.loadname = '资源加载中30%';
      if (window.location.host === 'huyuntong.com') {
        storeUrl = isProd ? 'www.biubiulink.com' : 'hyt.sjlexpress.com'; // 本地 测试环境默认只能测biubiulink店铺
      } else {
        this.loadname = '资源加载中40%';
        storeUrl = isProd
          ? `${window.location.host.split('.')[0].replace('m', 'www')}.${window.location.host.split('.')[1]
          }.${window.location.host.split('.')[2]}`
          : 'www.biubiulink.com'; // 本地 测试环境默认只能测biubiulink店铺
      }
      par = {
        storeUrl: storeUrl,
      };
    }
    this.http
      .APIASK(this.ports.getStoreInfo, 'get', par)
      .then((res) => {
        this.loadname = '资源加载中50%';
        localStorage.setItem('shopkey', JSON.stringify(res));
        // 判断登录状态
        if (!localStorage.getItem('mupressMobiltoken')) {
          this.loadname = '资源加载中60%';
          this.loading = false;
          this.$router
            .replace({
              name: 'Login',
              query: { parentCode: parentCode },
            })
            .catch((err) => {
              // console.log(err)
            });
        } else {
          this.loadname = '资源加载中70%';
          this.loading = false;
          this.$router
            .replace({
              path: '/',
              query: { parentCode: parentCode },
            })
            .catch((err) => {
              // console.log(err)
            });
        }
      })
      .catch((err) => {
        this.loadname = '资源加载中90%';
        this.loading = false;
        this.$router.replace({ path: '404' });
      });
  },
  methods: {
    getwein() {
      // APP Webview跳转进入
      this.http
        .APIASK(this.ports.wxOauth, 'get', {
          code: getUrlKey('code', window.location.href),
          state: getUrlKey('state', window.location.href),
        })
        .then((res) => {
          if (res.object) {
            localStorage.setItem('couplist', JSON.stringify(res.object));
          }
          localStorage.setItem('mupressMobiltoken', res.accessToken);
          localStorage.setItem('refreshToken', res.refreshToken);
          this.http
            .APIASK(this.ports.getUserInfo, 'get')
            .then((res) => {
              console.log('userinfoMobie', res);
              localStorage.setItem('userinfoMobie', JSON.stringify(res));
              if (parseInt(getUrlKey('showurl', window.location.href)) === 1) {
                window.location.href = window.location.origin + '/res/m';
              } else {
                window.location.href = window.location.origin;
              }
              // let path = this.$route.path; //先获取路由路径
              //     this.$router.push(path);
              //   this.loading = false;
              //   return false;
            })
            .catch((err) => {
              this.loading = false;
              return false;
            });
        })
        .catch((err) => {
          this.loading = false;
          return false;
        });
    },
    getPath() {
      this.path = this.$route.path;
    },
    go(path) {
      this.path == path ? null : this.$router.push({ path: path });
    },
    reload() {
      this.isReloadAlive = false;
      this.$nextTick(function () {
        this.isReloadAlive = true;
      });
    },
    appContext() {
      this.http.APIASK(this.ports.appContext, 'post').then((res) => {
        localStorage.setItem('appUrl', JSON.stringify(res));
      });
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow-y: scroll;
  height: 100vh;
  width: 100%;
}

.navbar {
  height: 1.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  font-size: 0.2rem;
}

#nav {
  border-top: 1px solid #cccccc;
  position: fixed;
  bottom: 0;
  width: 100%;
  font-size: 32px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #ffffff;
  z-index: 99;
}

#nav a {
  font-weight: bold;
  color: #888888;
  text-decoration: none;
}

.active {
  color: #e32c1a;
}
</style>
